import React from 'react';
import { Loader } from 'semantic-ui-react';

const Loading: React.FC = () => <Loader data-testid="loader" active />;

export default Loading;
